import { graphql } from 'relay-runtime';

export const getStudentRoadmapByGrade = graphql`
  query ProgressStudentsRoadmapByGradeQuery($filter: StudentRoadmapProgressByGradeFilterInput!) {
    studentRoadmapProgressByGrade(filter: $filter) {
      currentRoadmapId
      currentRoadmapName
      gradeSummaries {
        gradeName
        demonstrated
        total
      }
      studentLastName
      studentFirstName
      studentId
      studentPublicUserId
    }
  }
`;

export const getStudentGrowthAndEngagement = graphql`
  query ProgressStudentsGrowthAndEngagementQuery($filter: StudentProgressReportFilterInput!) {
    studentProgressReport(filter: $filter) {
      assessmentsTakenSinceLastPass
      currentRoadmapId
      currentRoadmapName
      lastPassedSkill
      roadmapSkillsRemaining
      skillsAttemptedButNotPassed
      skillsDemonstratedOnDiagnostic
      skillsPassedSinceDiagnostic
      totalAssessmentsTaken
      totalRoadmapSkills
      student {
        firstName
        id
        lastName
        publicUserId
      }
    }
  }
`;
